import DoubleFA from 'modules/User/Security/2fa/DoubleFA'
import Reducer from 'modules/User/Security/2fa/reducer'
import Sagas from 'modules/User/Security/2fa/saga'

export default DoubleFA

export { Sagas, Reducer }
